import React, { useState } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import './ErrorWindow.css';
export default function ErrorWindow(props) {
  //const getShow = () => props.showError;
  const [show, setShow] = useState(false);
  const [errorInfo, setErrorInfo] = useState(props.errorInfo);
  const handleClose = () => setShow(false);
  function pokazOkno(errorinfo) {
    // The parent component can call this function.
    // The parent component can call this function.
    console.log("someChildFunction" + errorinfo + " s");
    setErrorInfo(errorinfo);
    setShow(true);

  }
  // {props.biRef.someParentFunction()}
  props.biRef.pokazOkno = pokazOkno;
  return (
    <>
      <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
        className="obramowanie"
      >
        <Modal.Header className="tytul-blad" closeButton>
          <Modal.Title>Błąd</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {errorInfo}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="danger" onClick={handleClose}>
            Zamknij
            </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export const ErrorWindowEx = () => {
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const [errorInfo, setErrorInfo] = useState("sss");
  function pokazOkno(errorinfo) {
    // The parent component can call this function.
    // The parent component can call this function.
    console.log("someChildFunction" + errorinfo + " s");
    setErrorInfo(errorinfo);
    setShow(true);

  }
  return (
    <>
    <Modal
      show={show}
      onHide={handleClose}
      backdrop="static"
      keyboard={false}
    >
      <Modal.Header className="tytul" closeButton>
        <Modal.Title>Błąd</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {errorInfo}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Zamknij
          </Button>
      </Modal.Footer>
    </Modal>
  </>
  );
};
